import { render, staticRenderFns } from "./TeamplannerEventCard.vue?vue&type=template&id=10736dbf"
import script from "./TeamplannerEventCard.vue?vue&type=script&lang=js"
export * from "./TeamplannerEventCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports